// @mui
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
// routes
import { usePathname } from 'src/routes/hook';
import { RouterLink } from 'src/routes/components';
// components
import Logo from 'src/components/logo';
import Iconify from 'src/components/iconify';
import { useResponsive } from 'src/hooks/use-responsive';
import { type } from 'os';
import { paths } from 'src/routes/paths';
import { useLocales } from 'src/locales';

// ----------------------------------------------------------------------
const footerData = [
  {
    name: 'Community',
    children: [
      {
        name: 'LinkedIn',
        href: 'https://www.linkedin.com/company/code-engine/',
        icon: 'mdi:linkedin',
      },
    ],
  },
  {
    name: 'Products',
    children: [
      { name: 'Pathen', href: paths.pathen },
      { name: 'Testimonials', href: '#testimonials' },
      {
        name: 'Careers',
        href: 'https://www.linkedin.com/company/code-engine/jobs/?viewAsMember=true',
      },
    ],
  },
  {
    name: 'Contact',
    children: [
      { name: 'Email', href: paths.contact },
      { name: 'Privacy Policy', href: paths.privacy },
      { name: 'Terms of Service', href: paths.tnc },
      { name: 'Imprint', href: paths.imprint },
      { name: 'Cookie Policy', href: paths.cookiePolicy },
    ],
  },
];
// ----------------------------------------------------------------------
export default function Footer() {
  const mdUp = useResponsive('up', 'md');
  const { t } = useLocales();
  return (
    <Box
      sx={{
        py: '50px',
        width: '100%',
        borderTop: (theme) => `1px solid ${theme.palette.secondary.darker}`,
      }}
    >
      <Container maxWidth="xl">
        <Grid container maxWidth="100vw" spacing={mdUp ? 10 : 5}>
          <Grid xs={12} sm={6} md={3}>
            <Logo />
          </Grid>

          {footerData.map((footer) => (
            <Grid key={footer.name} xs={12} sm={6} md={3}>
              <Stack direction="column" spacing={2}>
                <Typography variant="h4">{t(footer.name)}</Typography>
                {footer.children.map((child) => (
                  <Link
                    key={child.name}
                    href={child.href}
                    underline="none"
                    color="inherit"
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      '&:hover': {
                        textDecoration: 'underline',
                      },
                    }}
                  >
                    <Typography variant="body2" sx={{}}>
                      {t(child.name)}
                    </Typography>
                  </Link>
                ))}
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
